'use client';

import type { CustomerOrder } from '@eliadmin/core/src/api/customers/customers-types';
import { useRepeatOrder } from '@eliadmin/core/src/hooks/cart/use-repeat-order';
export type { RepeatOrderResult as ReorderResult } from '@eliadmin/core/src/utils/repeat-order';

export function useReorder(order: Pick<CustomerOrder, 'id'>) {
  return useRepeatOrder(order.id);
}
